// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
module.exports = require('./er')(require('./assertion-error'));
